import React from "react";
import BackgroundImage from "./images/new-background.png";

const HeaderSection = ({ title, description, descriptionClass, header }) => {
  return (
    <div
      className="relative w-full h-[300px] bg-cover bg-center "
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50" />

      <div className="relative flex flex-col gap-6 items-center justify-center h-full text-white px-4 text-center">
        {header && <div className="bg-[#E4089199] px-8 py-5 font-bold text-[40px] rounded-full">{header}</div>}
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
          {title}
        </h1>
        <p className="mt-2 text-light-gray font-normal text-base md:text-lg">
          <span className={`${descriptionClass}`}>{description}</span>
        </p>
      </div>
    </div>
  );
};

export default HeaderSection;
